import { TextOnlySearchEditor } from "./TextOnlySearch";
import { ResourceSelector } from "./ResourceSelector";
import { ServerGroupSelectorProps } from "./ServerGroupSelector";
import { useCallback } from "react";
import { clientSearchDef, clientSortFields } from "../section/api_client/def";
import { ClientListTable } from "../section/api_client/ApiClientList";

export function StorageApiClientSelector({ editor, selectSingle, children, autoFocusSearch }: ServerGroupSelectorProps) {
    const memoSearchEditor = useCallback(
        (props) => <TextOnlySearchEditor {...props} autoFocus={!!autoFocusSearch} />,
        [autoFocusSearch]
    );

    return (
        <ResourceSelector
            selector={{
                editor,
                selectSingle,
            }}
            kind='api_client'
            sortFields={clientSortFields}
            searchDef={clientSearchDef}
            searchComponent={memoSearchEditor}
            table={ClientListTable}
            context='selector'
            itemsFilter={x => x.permissions_group === 'storage'}
        >
            {children}
        </ResourceSelector>
    );
}